module.exports = __webpack_public_path__ + "static/media/failure-icon.afa35d2e.svg";